"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModeReferenceConditionSchema = void 0;
exports.isModeReferenceCondition = isModeReferenceCondition;
const zod_1 = require("zod");
exports.ModeReferenceConditionSchema = zod_1.z.object({
    mode: zod_1.z.string(),
    mode_state: zod_1.z.boolean(),
});
function isModeReferenceCondition(condition) {
    return condition.mode !== undefined;
}
//# sourceMappingURL=ModeReferenceCondition.js.map